export const buildURLWithParams = (url, f) => {
    const p = new URLSearchParams();
    Object.entries(f).forEach(([k, v]) => {
      if (v !== null && v !== "" && v !== undefined) {
        if (Array.isArray(v)) v.forEach((item) => p.append(k, item));
        else p.append(k, v);
      }
    });
    const qs = p.toString(); 
    return qs ? `${url}?${qs}` : url; // avoid trailing "?"
  };

export const buildParams = (f) => {
    const p = new URLSearchParams();
    Object.entries(f).forEach(([k, v]) => {
      if (v !== null && v !== "" && v !== undefined) {
        if (Array.isArray(v)) v.forEach((item) => p.append(k, item));
        else p.append(k, v);
      }
    });
    return p;
}